module.exports = __webpack_public_path__ + "img/rmc-logo.6973dbd6.jpg";